var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"banner-wrapper"},[_c('div',{staticClass:"banner-text"},[_vm._v("科技赋能 让智慧教育触手可及")])])}]

export { render, staticRenderFns }